import { cn } from './cn';

/**
 * <Kbd>Ctrl</Kbd> + <Kbd>K</Kbd>
 *
 * Estilo: pequena tecla con borde sutil. Usado en command palette,
 * tooltips y hints de teclado.
 */
const Kbd = ({ children, className, ...rest }) => (
    <kbd
        className={cn(
            'inline-flex items-center justify-center min-w-[20px] h-5 px-1.5',
            'text-[10px] font-mono font-medium text-muted',
            'bg-surface-2 border border-line rounded-md',
            'shadow-[inset_0_-1px_0_rgba(0,0,0,0.05)]',
            className
        )}
        {...rest}
    >
        {children}
    </kbd>
);

export default Kbd;
